import React, { useMemo } from 'react';
import { TranslationKey } from '../../../../../../../../types/translation/TranslationKey';
import {
  ProductTransaction,
  ProductTransactionStatus,
  ProductTransactionType,
} from '../../../../../../../../types/productTransaction';
import { Grid } from '@mui/material';
import { ProductMasterData } from '../../../../../../../../types/product_master_data/productMasterData';
import { t } from '../../../../../../../../types/translation/Translator';
import { Container } from '../../../../../../../../types/container';
import { TextInput } from '../../../../../../../components/TextInput';

interface ProductTransactionDestinationLPNProps {
  transaction: ProductTransaction;
  setTransaction: React.Dispatch<React.SetStateAction<ProductTransaction>>;
  productMasterData?: ProductMasterData;
  container?: Container;
  disabled?: boolean;
}

export default function ProductTransactionDestinationLPN({
  transaction,
  setTransaction,
  productMasterData,
  container,
  disabled = false,
}: ProductTransactionDestinationLPNProps) {
  if (!productMasterData) return null;

  const isDefined = useMemo(() => {
    if (transaction.product.fromProductId && transaction.containerTransactionId) return true;
    return false;
  }, []);

  if (!productMasterData.lpnManaged) return null;
  if (transaction.type !== ProductTransactionType.inbound) return null;

  return (
    <Grid item xs={6}>
      <TextInput
        disabled={transaction.status !== ProductTransactionStatus.created || disabled || isDefined}
        mandatory
        label={t(TranslationKey.lpn).singular.label}
        placeholder={t(TranslationKey.lpn).singular.label}
        onChange={v => setTransaction(transaction => transaction.withLPN(v))}
        value={transaction.product.lpn}
      />
    </Grid>
  );
}
